import { Map } from 'immutable';
import Constants from '../../constants/index';

import { SpaceRecord } from '../../records/index';
import { spaceReducerMerger } from '../helpers/entities';

export const DEFAULT_STATE = Map({});

const spaceWithWatching = spaceReducerMerger(
	[
		Constants.IS_WATCHING_SPACE,
		Constants.WATCH_SPACE,
		Constants.UNWATCH_SPACE,
		Constants.QUERY_SPACES,
		Constants.FETCH_QUESTION_LIST,
		Constants.FETCH_QUESTION_RELATED,
		Constants.SEARCH_QUESTIONS,
	],
	'spaces',
	SpaceRecord,
	DEFAULT_STATE,
);

export default spaceWithWatching;
